import axios from 'axios';

export const HTTP = axios.create({
  baseURL: `https://alsukkary.sd.zain.com/AlsukareAPIs/APIs/`
})

